/**
 * NFP-based nesting engine v3
 * Dense grid candidates + NFP collision + GA optimization
 */
(function(global){
'use strict';

var NFPN = {};

function polyBounds(p){var x0=Infinity,y0=Infinity,x1=-Infinity,y1=-Infinity;for(var i=0;i<p.length;i++){if(p[i].x<x0)x0=p[i].x;if(p[i].y<y0)y0=p[i].y;if(p[i].x>x1)x1=p[i].x;if(p[i].y>y1)y1=p[i].y;}return{x:x0,y:y0,w:x1-x0,h:y1-y0};}
function pip(px,py,poly){var ins=false;for(var i=0,j=poly.length-1;i<poly.length;j=i++){var xi=poly[i].x,yi=poly[i].y,xj=poly[j].x,yj=poly[j].y;if(((yi>py)!==(yj>py))&&(px<(xj-xi)*(py-yi)/(yj-yi)+xi))ins=!ins;}return ins;}
function translatePoly(poly,dx,dy){return poly.map(function(p){return{x:p.x+dx,y:p.y+dy};});}

// SVGnest winding: needs negative area (CCW)
function toNFPWinding(poly){var a=0;for(var i=0,j=poly.length-1;i<poly.length;j=i++)a+=(poly[j].x+poly[i].x)*(poly[j].y-poly[i].y);if(a>0)return poly.slice().reverse();return poly.slice();}

// ==================== NFP COMPUTATION ====================

function computeNFP(A, B) {
  if (typeof GeometryUtil === 'undefined') return null;
  try {
    var nfp = GeometryUtil.noFitPolygon(toNFPWinding(A), toNFPWinding(B), false, false);
    if (nfp && nfp.length > 0 && nfp[0] && nfp[0].length >= 3) return nfp;
  } catch(e) {}
  // Fallback: bbox NFP
  var bA = polyBounds(A), bB = polyBounds(B);
  return [[
    {x: bA.x - bB.x - bB.w, y: bA.y - bB.y - bB.h},
    {x: bA.x + bA.w - bB.x, y: bA.y - bB.y - bB.h},
    {x: bA.x + bA.w - bB.x, y: bA.y + bA.h - bB.y},
    {x: bA.x - bB.x - bB.w, y: bA.y + bA.h - bB.y}
  ]];
}

// ==================== PLACEMENT (dense grid + NFP check) ====================

function placePieces(items, binW, binH, order, rotations, nfpCache, margins, gridStep) {
  var placements = [];
  var placedPolys = [];
  var ml = margins ? margins.l : 0, mr = margins ? margins.r : 0;

  for (var oi = 0; oi < order.length; oi++) {
    var idx = order[oi];
    var item = items[idx];
    var rot = rotations[idx];
    var piece = (rot && typeof NestEngine !== 'undefined') ? NestEngine.polyRotate(item.polyMm, typeof rot === 'string' ? parseInt(rot) : rot) : item.polyMm;
    var pb = polyBounds(piece);

    // Valid X range for this piece
    var xMin = ml - pb.x;
    var xMax = binW - mr - pb.x - pb.w;
    var yMin = -pb.y;
    if (xMax < xMin) continue; // piece too wide

    // Compute forbidden zones (NFP with all placed pieces)
    var forbiddenZones = [];
    for (var pi = 0; pi < placements.length; pi++) {
      var placed = placements[pi];
      var key = placed.itemIdx + '_' + (placed.rotation||0) + '_' + idx + '_' + rot;
      var nfpLoops = nfpCache[key];
      if (!nfpLoops) {
        nfpLoops = computeNFP(placedPolys[pi], piece);
        nfpCache[key] = nfpLoops;
      }
      if (!nfpLoops) continue;
      nfpLoops.forEach(function(loop) {
        if (loop && loop.length >= 3) {
          forbiddenZones.push(translatePoly(loop, placed.x, placed.y));
        }
      });
    }

    // Generate dense grid of candidate positions
    var step = gridStep || 10; // mm
    var currentMaxY = 0;
    placements.forEach(function(pl) { currentMaxY = Math.max(currentMaxY, pl.y + pl.h); });
    var searchMaxY = currentMaxY + pb.h + step * 2;

    var bestPos = null, bestScore = Infinity;

    // Scan Y from top (0) downward, X from left to right
    for (var cy = yMin; cy <= searchMaxY; cy += step) {
      for (var cx = xMin; cx <= xMax; cx += step) {
        // Check forbidden zones
        var forbidden = false;
        for (var fi = 0; fi < forbiddenZones.length; fi++) {
          if (pip(cx, cy, forbiddenZones[fi])) { forbidden = true; break; }
        }
        if (forbidden) continue;

        // Score: minimize total height used, then minimize X
        var newMaxY = Math.max(currentMaxY, cy + pb.y + pb.h);
        var score = newMaxY * 10 + cx;
        if (score < bestScore) {
          bestScore = score;
          bestPos = {x: cx, y: cy};
          // Early exit if we found a position at or below current max height
          if (cy + pb.y + pb.h <= currentMaxY + step) { cx = xMax + 1; cy = searchMaxY + 1; }
        }
      }
      // If we already found something at this Y level, don't search further down
      if (bestPos && bestPos.y <= cy) break;
    }

    // Also check NFP boundary vertices (for precise interlocking positions)
    forbiddenZones.forEach(function(fz) {
      fz.forEach(function(v) {
        // Check points just outside the forbidden zone
        var offsets = [{x:step,y:0},{x:-step,y:0},{x:0,y:step},{x:0,y:-step},{x:step,y:step},{x:-step,y:-step}];
        offsets.forEach(function(off) {
          var cx2 = v.x + off.x, cy2 = v.y + off.y;
          if (cx2 < xMin || cx2 > xMax || cy2 < yMin) return;
          var forbidden2 = false;
          for (var fi2 = 0; fi2 < forbiddenZones.length; fi2++) {
            if (pip(cx2, cy2, forbiddenZones[fi2])) { forbidden2 = true; break; }
          }
          if (forbidden2) return;
          var newMaxY2 = Math.max(currentMaxY, cy2 + pb.y + pb.h);
          var score2 = newMaxY2 * 10 + cx2;
          if (score2 < bestScore) { bestScore = score2; bestPos = {x: cx2, y: cy2}; }
        });
      });
    });

    if (bestPos) {
      placements.push({
        itemIdx: idx, motifId: item.mid,
        x: bestPos.x, y: bestPos.y, w: pb.w, h: pb.h,
        rotation: rot, rotated: rot !== 0 && rot !== '0',
        polygon: translatePoly(piece, bestPos.x, bestPos.y)
      });
      placedPolys.push(piece);
    }
  }
  return placements;
}

// ==================== GA + SA ====================

NFPN.nest = function(items, binW, binH, opts) {
  opts = opts || {};
  var mg = opts.margins || {l:0,r:0,t:0,b:0};
  var popSz = opts.population || 16;
  var gens = opts.generations || 20;
  var saIters = opts.saIterations || 150;
  var onProg = opts.onProgress || function(){};

  // Reasonable max height
  var totalH = 0, maxPieceH = 0;
  items.forEach(function(it) { var h = Math.max(it.wMm, it.hMm); totalH += h; if(h > maxPieceH) maxPieceH = h; });
  binH = Math.min(binH, Math.max(totalH * 2, maxPieceH * 4, 2000));

  var n = items.length;
  if (!n) return Promise.resolve(null);

  // Grid step: adaptive based on smallest piece
  var minDim = Infinity;
  items.forEach(function(it) { minDim = Math.min(minDim, it.wMm, it.hMm); });
  var gridStep = Math.max(3, Math.min(20, Math.round(minDim / 4)));

  // Allowed rotations per item
  var rots = opts.rotations || [0, 180];
  var itemRots = [];
  for (var i = 0; i < n; i++) {
    if (items[i].grainAngle !== null && items[i].grainAngle !== undefined && typeof NestEngine !== 'undefined') {
      itemRots.push(NestEngine.grainRotations(items[i].grainAngle, items[i].napDir || 'bi'));
    } else if (items[i].pivotable) {
      itemRots.push(rots);
    } else {
      itemRots.push([0]);
    }
  }

  var nfpCache = {};

  function randInd(){var o=[];for(var i=0;i<n;i++)o.push(i);for(var i=n-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=o[i];o[i]=o[j];o[j]=t;}var r=[];for(var i=0;i<n;i++){var ir=itemRots[i];r.push(ir[Math.floor(Math.random()*ir.length)]);}return{order:o,rots:r,fit:Infinity,placed:0,maxH:0,_pl:null};}
  function seedInd(sortFn){var o=[];for(var i=0;i<n;i++)o.push(i);o.sort(sortFn);var r=[];for(var i=0;i<n;i++)r.push(itemRots[i][0]);return{order:o,rots:r,fit:Infinity,placed:0,maxH:0,_pl:null};}

  function evaluate(ind){
    var result = placePieces(items, binW, binH, ind.order, ind.rots, nfpCache, mg, gridStep);
    var maxH=0;
    result.forEach(function(pl){maxH=Math.max(maxH,pl.y+pl.h);});
    ind.placed=result.length; ind.maxH=maxH;
    ind.fit=maxH+(n-result.length)*99999; ind._pl=result;
  }

  function tournament(pop){var a=pop[Math.floor(Math.random()*pop.length)],b=pop[Math.floor(Math.random()*pop.length)];return a.fit<=b.fit?a:b;}
  function oxCross(p1,p2){var len=p1.length,a=Math.floor(Math.random()*len),b=Math.floor(Math.random()*len);if(a>b){var t=a;a=b;b=t;}var ch=new Array(len).fill(-1),used={};for(var i=a;i<=b;i++){ch[i]=p1[i];used[p1[i]]=1;}var ci=(b+1)%len;for(var i=0;i<len;i++){var pi2=(b+1+i)%len;if(!used[p2[pi2]]){ch[ci]=p2[pi2];ci=(ci+1)%len;}}return ch;}
  function cloneInd(i){return{order:i.order.slice(),rots:i.rots.slice(),fit:i.fit,placed:i.placed,maxH:i.maxH,_pl:i._pl};}

  return new Promise(function(resolve){
    var pop=[];
    pop.push(seedInd(function(a,b){return items[b].area-items[a].area;}));
    pop.push(seedInd(function(a,b){return Math.max(items[b].wMm,items[b].hMm)-Math.max(items[a].wMm,items[a].hMm);}));
    while(pop.length<popSz) pop.push(randInd());

    var gen=0, totalSteps=gens+1;

    function step(){
      pop.forEach(function(ind){if(ind.fit===Infinity)evaluate(ind);});
      pop.sort(function(a,b){return a.fit-b.fit;});
      var best=pop[0];
      var totArea=items.reduce(function(s,it){return s+it.area;},0);
      var uW=binW-mg.l-mg.r;
      onProg({generation:gen,totalGenerations:totalSteps,placed:best.placed,total:n,height:best.maxH,
        fill:uW*Math.max(1,best.maxH)>0?(totArea/(uW*Math.max(1,best.maxH))*100):0,
        phase:gen>=gens?'SA':'GA'});

      if(gen>=gens){
        var sb=cloneInd(best),sc=cloneInd(best);
        var temp=Math.max(1,sb.maxH*0.1),cool=Math.pow(0.01/Math.max(0.01,temp),1/Math.max(1,saIters));
        for(var si=0;si<saIters;si++){
          var nb=cloneInd(sc);
          if(Math.random()<0.5){var a2=Math.floor(Math.random()*n),b2=Math.floor(Math.random()*n);var tmp=nb.order[a2];nb.order[a2]=nb.order[b2];nb.order[b2]=tmp;}
          else{var ri=Math.floor(Math.random()*n);var ir=itemRots[ri];nb.rots[ri]=ir[Math.floor(Math.random()*ir.length)];}
          nb.fit=Infinity;evaluate(nb);
          var delta=nb.fit-sc.fit;
          if(delta<0||Math.random()<Math.exp(-delta/temp)){sc=nb;if(sc.fit<sb.fit)sb=cloneInd(sc);}
          temp*=cool;
        }
        var fp=sb._pl||[];
        var mH=0,uA=0;
        fp.forEach(function(pl){mH=Math.max(mH,pl.y+pl.h);uA+=items[pl.itemIdx]?items[pl.itemIdx].area:pl.w*pl.h;});
        onProg({generation:totalSteps,totalGenerations:totalSteps,placed:fp.length,total:n,height:mH,
          fill:uW*Math.max(1,mH)>0?(uA/(uW*Math.max(1,mH))*100):0,phase:'done'});
        resolve({placements:fp,placed:fp.length,total:n,height:mH,
          fill:uW*Math.max(1,mH)>0?(uA/(uW*Math.max(1,mH))*100):0,usedArea:uA});
        return;
      }

      var next=[cloneInd(pop[0])];
      if(pop.length>1)next.push(cloneInd(pop[1]));
      while(next.length<popSz){
        var pa=tournament(pop),pb=tournament(pop);
        var co=oxCross(pa.order,pb.order);
        var cr=[];for(var i=0;i<n;i++)cr.push(Math.random()<0.5?pa.rots[i]:pb.rots[i]);
        if(Math.random()<0.3){var a3=Math.floor(Math.random()*n),b3=Math.floor(Math.random()*n);var t3=co[a3];co[a3]=co[b3];co[b3]=t3;}
        if(Math.random()<0.3){var mi=Math.floor(Math.random()*n);var ir2=itemRots[mi];cr[mi]=ir2[Math.floor(Math.random()*ir2.length)];}
        next.push({order:co,rots:cr,fit:Infinity,placed:0,maxH:0,_pl:null});
      }
      pop=next; gen++;
      setTimeout(step,0);
    }
    step();
  });
};

global.NestNFP = NFPN;
})(window);
